import getActionsByDocument from '../../../../../components/logs/actions';

const DOCUMENT = 'COMPANY_LOGS_';

export default getActionsByDocument(DOCUMENT);
